import { render, staticRenderFns } from "./KarenV2Listing.vue?vue&type=template&id=2b2b8da6&"
import script from "./KarenV2Listing.vue?vue&type=script&lang=js&"
export * from "./KarenV2Listing.vue?vue&type=script&lang=js&"
import style0 from "./KarenV2Listing.vue?vue&type=style&index=0&id=2b2b8da6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports